import Mittens from 'mittens'

const obj = new Mittens()
const webDownload = (payload) => {
  const { url, name } = payload
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', name)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

window.ipcRenderer = {
  send: (channel, ...data) => {
    if (channel === 'download' && data[0]?.payload) {
      return webDownload(data[0].payload)
    }
    obj.emit(channel, ...data)
  },

  on: (channel, emitBrowser) => {
    obj.on(channel, emitBrowser)
  },

  off: (channel, emitBrowser) => {
    obj.off(channel, emitBrowser)
  }
}

window.mediaDevices = () => {
  return navigator.mediaDevices.getUserMedia({ audio: true }).then(async (stream) => {
    const devices = await navigator.mediaDevices.enumerateDevices()
    stream.getTracks().forEach(track => track.stop())
    return devices
  }).catch((err) => {
    console.log({ err })
  })
}

window.shell = {
  openExternal (url) {
    window.open(url, '_blank')
  }
}
